import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

// dayjs plugin extend는 모듈 import 시 1회만 실행 (중복 호출 안전)
dayjs.extend(utc);
dayjs.extend(timezone);

export const KST_TZ = "Asia/Seoul";

/**
 * 타임스탬프를 KST 기준 문자열로 포맷한다.
 * 시스템 TZ에 무관하게 항상 Asia/Seoul로 변환되며, "KST" suffix가 붙는다.
 *
 * @param {string|number|Date|null|undefined} ts - 입력 timestamp
 * @param {string} pattern - dayjs format pattern (기본: "YYYY-MM-DD HH:mm:ss")
 * @returns {string} 포맷된 문자열, 입력이 없거나 invalid면 "-"
 */
export const formatKst = (ts, pattern = "YYYY-MM-DD HH:mm:ss") => {
    if (ts == null) return "-";
    const d = dayjs(ts).tz(KST_TZ);
    if (!d.isValid()) return "-";
    return d.format(pattern) + " KST";
};

/**
 * 짧은 KST 포맷 (월/일 시:분 KST)
 */
export const formatKstShort = (ts) => formatKst(ts, "MM/DD HH:mm");

/**
 * 현재 시각을 KST dayjs 객체로 반환한다.
 */
export const kstNow = () => dayjs().tz(KST_TZ);

/**
 * 라벨(채택/폐기) 시각 문자열을 표시용으로 정규화한다. (DAS-126)
 *
 * 저장값은 KST 벽시계 문자열이다:
 *   - 신규: "YYYY-MM-DD HH:mm:ss" → 분까지만 노출 ("YYYY-MM-DD HH:mm")
 *   - 레거시: "YYYY-MM-DD" (날짜 단위) → 그대로 노출
 *
 * 이미 KST 벽시계이므로 TZ 재변환(formatKst)을 하지 않는다(이중 보정 방지).
 *
 * @param {string|null|undefined} s
 * @returns {string} 정규화된 문자열, 없으면 ""
 */
export const formatLabeledAt = (s) => {
    if (!s) return "";
    return s.length > 16 ? s.slice(0, 16) : s;
};
